module.exports = __webpack_public_path__ + "img/bailiffs_introduction.496e35ea.svg";